import { cn } from '~/utils/tailwind-utils'

export const Card = ({
  children,
  grow = true,
  className,
}: {
  children: React.ReactNode | React.ReactNode[]
  grow?: boolean
  className?: string
}) => {
  return (
    <div
      className={cn(
        'flex-shrink space-y-4 border-gray-200 md:rounded-2xl md:border md:bg-white md:p-5 md:shadow-lg md:shadow-gray-300/5 dark:border-gray-800 dark:bg-black dark:md:shadow-gray-950/10',
        {
          'flex-grow': grow,
        },
        className,
      )}
    >
      {children}
    </div>
  )
}
